// extracted by mini-css-extract-plugin
export var reviews = "reviews-module--reviews--o9xP5";
export var list = "reviews-module--list--kKL3g";
export var slider = "reviews-module--slider--tS+JH";
export var item = "reviews-module--item--V4Mwc";
export var itemHeader = "reviews-module--itemHeader--7Wre1";
export var itemTitle = "reviews-module--itemTitle--E+1x+";
export var itemContent = "reviews-module--itemContent--nTtRS";
export var rate = "reviews-module--rate--Th3sX";